<template>
  <div
    :class="['cf-overlay', { 'cf-cursor-wait': withLoader, 'cf-overlay--status': message }]"
    @click="overlayClickHandler"
  >
    <div
      v-if="withLoader"
      class="cf-page-loader cf-flex--column cf-flex--gap-16"
    >
      <div :class="['cf-loader', { 'cf-loader--light': message }]" />

      <p
        v-if="message"
        class="cf-overlay__message"
      >
        {{ message }}
      </p>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'CfBackgroundOverlay',

    props: {
      withLoader: {
        type: Boolean,
        default: false
      },

      message: {
        type: String,
        default: null
      }
    },

    mounted() {
      this.onComponentMounted();
    },

    unmounted() {
      this.onComponentDestroyed();
    },

    methods: {
      onComponentMounted() {
        document.body.classList.add('cf-overlay-no-scroll');
      },

      onComponentDestroyed() {
        document.body.classList.remove('cf-overlay-no-scroll');
      },

      overlayClickHandler() {
        this.$emit('close-backgound-overlay');
      }
    }
  };
</script>

